import EFileSizeUnit from '../../entities/EFileSizeUnit';

export default (fileSize: number, unit: EFileSizeUnit) => {
	switch (unit) {
		case 'GB':
			return fileSize * 1073741824;
		case 'MB':
			return fileSize * 1048576;
		case 'KB':
			return fileSize * 1024;
		case 'B':
		default:
			return fileSize;
	}
};
